'use client';

import { useEffect, useRef } from 'react';

import { useAlertBanner, useScrollToSection } from '@libs/common-next';
import { AlertBanner } from './AlertBanner';

type AlertBannerContainerProps = {
    isChild?: boolean;
};

export function AlertBannerContainer({ isChild }: AlertBannerContainerProps) {
    const { alert, childAlert } = useAlertBanner();

    const currentAlert = isChild ? childAlert : alert;
    const elementRef = useRef<HTMLDivElement | null>(null);
    const scrollToSection = useScrollToSection();

    useEffect(() => {
        if (elementRef?.current && !alert?.skipScrollToAlert) {
            scrollToSection('alert-banner-container');
        }
    }, [alert]);

    return currentAlert ? (
        <div ref={elementRef} className="alert-banner-container" id="alert-banner-container">
            <AlertBanner
                header={currentAlert.header}
                variant={currentAlert.variant}
                iconName={currentAlert?.icon}
                dismissible={currentAlert?.dismissible}
            >
                {currentAlert.text}
            </AlertBanner>
        </div>
    ) : null;
}
